import { NotificationService } from 'src/app/shared/services/notification.service';
import { FeatureKey } from './../../../_models/feature';
import { EmployeeServices } from './../../employees/services/employee.services';
import { inject, Component, OnInit, Input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { SelectItem } from 'primeng/api';

import { ValidationService } from '../../shared/services/validation.service';

import { AdminUser, UserAddressPropertyDto } from './../models/adminuser';
import { AdminUserService } from './../services/adminuser.service';
import { UserService } from './../../users/services/user.service';
import {
  AdminSaveUsers,
  AdminUserAvatarFile,
  AdminUserSignatureFile
} from './../models/adminuser';
import { AlertService } from '../../../_services';
import { BaseServices } from '../../kuba.services';
import { Subscription } from 'rxjs';
import { LanguageId } from 'src/app/_models/language-id.enum';
@Component({
  selector: 'adminuser-add',
  templateUrl: 'new-adminuser.component.html',
  standalone: false
})
export class AdminUserAddComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  adminUserAddForm: FormGroup;
  userId: number;
  user: AdminUser;
  public Id?: number;
  fileName: string;
  uploadRequest: any;
  isPasswordValid = false;
  userImage: string;
  isNewUser = true;
  private subscriptions: Subscription[] = [];
  //#endregion

  //#region constructor
  constructor(
    private fb: FormBuilder,
    private userService: AdminUserService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private employeeServices: EmployeeServices
  ) {}
  //#endregion

  //#region page-event
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.adminUserAddForm = this.fb.group({
      Name: ['', Validators.required],
      Email: ['', [Validators.required, ValidationService.emailValidator]],
      Avatar: [''],
      newPasswordValidation: this.fb.group(
        {
          Password: ['', Validators.required],
          ConfirmPassword: ['', Validators.required]
        }
      ),
      Username: ['', [Validators.required], this.isUserNameUnique.bind(this)],
      LanguageId: [''],
      Status: [1, Validators.required],
      Address: [''],
      Mobile: ['', Validators.required],
      PhoneCode: [2],
      PostalAddress: [''],
      Location: [''],
      ZipCode: [''],
      NewsLetter: ['']
    });
    this.subscriptions.push(
      this.userService.getImage$.subscribe(imagePath => {
        this.userImage = imagePath ? imagePath : '';
      })
    );
    this.userService.checkNewUser(true);
  }
  //#endregion

  //#region methods
  saveChanges() {
    if (this.adminUserAddForm.invalid || this.adminUserAddForm.pending) {
      return;
    }
    let userBusinessPropertyDto = new UserAddressPropertyDto();
    userBusinessPropertyDto.UserId = 0;
    userBusinessPropertyDto.User.CreatedBy = BaseServices.UserId;
    userBusinessPropertyDto.User.Name = this.adminUserAddForm.value.Name;
    userBusinessPropertyDto.User.Email = this.adminUserAddForm.value.Email;
    userBusinessPropertyDto.User.Username =
      this.adminUserAddForm.value.Username;
    userBusinessPropertyDto.User.LanguageId =
      this.adminUserAddForm.value.LanguageId || LanguageId.English;
    userBusinessPropertyDto.User.RoleId = 1;
    userBusinessPropertyDto.User.ApplicationId = BaseServices.ApplicationId;
    userBusinessPropertyDto.User.PostalAddress =
      this.adminUserAddForm.value.PostalAddress;
    userBusinessPropertyDto.User.BusinessId = BaseServices.BusinessId;
    userBusinessPropertyDto.User.Password =
      this.adminUserAddForm.value.newPasswordValidation['Password'];
    userBusinessPropertyDto.User.Status = 1;
    userBusinessPropertyDto.User.FeatureId = FeatureKey.EMPLOYEES;
    userBusinessPropertyDto.User.Mobile =
      this.adminUserAddForm.value.Mobile.toString();
    userBusinessPropertyDto.User.CountryCode =
      this.adminUserAddForm.value.PhoneCode.toString();
    userBusinessPropertyDto.User.Id = 0;
    userBusinessPropertyDto.User.Address = this.adminUserAddForm.value.Address;
    userBusinessPropertyDto.User.Zip = this.adminUserAddForm.value.ZipCode;
    userBusinessPropertyDto.User.Location =
      this.adminUserAddForm.value.Location;
    userBusinessPropertyDto.User.Avatar = this.userImage;
    this.subscriptions.push(
      this.userService.addusers(userBusinessPropertyDto).subscribe(result => {
        this.notifications.success('UI_NOTIFICATIONS.SAVED');
      })
    );
    this.resetForm();
  }
  resetForm() {
    this.adminUserAddForm = this.fb.group({
      Name: '',
      Email: '',
      Avatar: '',
      newPasswordValidation: this.fb.group({
        Password: '',
        ConfirmPassword: ''
      }),
      Username: '',
      LanguageId: '',
      Status: '',
      Address: '',
      Mobile: '',
      PhoneCode: '',
      PostalAddress: '',
      Location: '',
      ZipCode: '',
      NewsLetter: ''
    });
  }

  // TODO: Upload profile image need to be implemented

  onUpload(event: any) {
    for (let file of event.files) {
      this.fileName = file.name;
    }
  }
  /**
   * user name validation
   */
  usernameWarning: string | null = null;

  isUserNameUnique(control: FormControl) {
    const q = new Promise(resolve => {
      setTimeout(() => {
        this.subscriptions.push(
          this.employeeServices.getUserNameStatus(control.value).subscribe(
            (status: string) => {
              this.usernameWarning = null;
              if (status === 'Active') {
                this.usernameWarning = 'active';
                resolve({ invalidUserName: true, usernameStatus: 'active' });
              } else if (status === 'Deleted') {
                this.usernameWarning = 'deleted';
                resolve(null);
              } else if (status === 'Inactive') {
                this.usernameWarning = 'inactive';
                resolve(null);
              } else {
                resolve(null);
              }
            },
            () => {
              resolve({ invalidUserName: true, usernameStatus: 'active' });
            }
          )
        );
      }, 1000);
    });
    return q;
  }

  onValidChange(valid: boolean) {
    const pwGroup = this.adminUserAddForm.get('newPasswordValidation') as FormGroup;
  
    this.isPasswordValid = valid;
  
    if (valid) {
      pwGroup.setErrors(null);
    } else {
      pwGroup.setErrors({ invalidPassword: true });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion
}
